import { render } from "./volume-down.vue?vue&type=template&id=60f8907b"
const script = {}

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/icons/volume-down.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "60f8907b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('60f8907b', __exports__)) {
    api.reload('60f8907b', __exports__)
  }
  
  module.hot.accept("./volume-down.vue?vue&type=template&id=60f8907b", () => {
    api.rerender('60f8907b', render)
  })

}


export default __exports__